import Vue from 'vue'
import VueRouter from 'vue-router'
import { checkPrivilege, pages } from './privilege'
import Login from './Login.vue'
import Admin from './Admin.vue'
import Home from './panels/Home.vue'
import { store } from '../../store'
import { message } from 'ant-design-vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '权限验证',
        },
        component: Login
    },
    {
        path: '/',
        name: 'admin',
        redirect: '/home',
        meta: {
            title: '主页',
        },
        component: Admin,
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    title: '主页',
                    privilege: {},
                },
                component: Home,
            },
            ...pages
        ]
    },
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.name !== "login") { // 登陆页不检测
        if (!from.name) { // 首次进入页面
            await store.dispatch("fetchUserInfo");
            await store.dispatch("$privilege/fetch");
        }
        if (!store.state.hasLogin || !store.state.$privilege.privileges) {
            return next('/login');
        } else if (to.params.privilege && !checkPrivilege(to.meta.privilege)) {
            message.error("没有对应权限");
            return next(false);
        }
    }
    document.title = "后台管理 - " + to.meta.title;
    next();
})

export default router
